import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const roundedBox = geo.createNode('roundedBox');

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [roundedBox],
		autoLayout: true,
	};
}
// export const sopRoundedBox = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/roundedBox`,
// 		createData,
// 		relatedNodes: [RoundedBoxSopNode],
// 	}),
// ];
